import styled from "styled-components";

export default styled.input`
  margin: 1px 2px;
  padding: 3px 8px 4px;
  border: 1px solid ${props => props.theme.panelBorder};
  border-radius: 4px;
  box-sizing: border-box;
  ${props => props.width && `width: ${props.width}px`};
`;



// WEBPACK FOOTER //
// ./src/module-common/Input.js